import { getCloudflareTraceResult, useCountriesQuery } from '@capsicum/common';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

/**
 *  Returns the user country based on the IP address
 */
export const useUserCountryQueries = () => {
	const { data: countries, isLoading: isCountriesLoading } = useCountriesQuery();

	const { data: cloudfareTraceData, isLoading: cloudfareTraceDataLoading } = useQuery({
		queryFn: getCloudflareTraceResult,
		queryKey: ['cloudflareTraceResult']
	});

	return {
		data: useMemo(() => {
			const countryCode = cloudfareTraceData && /loc=*\s*([A-Za-z]{2})/.exec(cloudfareTraceData)?.[1];

			return countryCode ? countries?.find(c => c.iso2 === countryCode) : undefined;
		}, [cloudfareTraceData, countries]),

		isLoading: useMemo(
			() => isCountriesLoading || cloudfareTraceDataLoading,
			[isCountriesLoading, cloudfareTraceDataLoading]
		)
	};
};
